import geoJson from '../json/geoJson.json';
// 获取省级列表
const getProvinceList = () => {
  return geoJson[0].districts.map(item => {
    return {
      ...item,
      districts: [],
      citycode: []
    };
  });
};
// 获取市级列表
const getCityList = () => {
  let cityList = [];
  geoJson[0].districts.forEach(item => {
    item.districts.forEach(cIem => {
      cityList.push({
        ...cIem,
        districts: []
      });
    })
  });
  return cityList
};

// 获取市级数据
const getCity = (cityCode) => {
  let cityList = null;
  geoJson[0].districts.forEach(item => {
    const result = item.districts.find(cIem => {
      return cIem.citycode == cityCode
    })
    if(result) {
      cityList = result
    }
  });
  return cityList
};
// 获取市级数据
const getCityByName = (cityName) => {
  let cityList = null;
  geoJson[0].districts.forEach(item => {
    const result = item.districts.find(cIem => {
      return cIem.name.indexOf(cityName) != -1
    })
    if(result) {
      cityList = result
    }
  });
  return cityList
};

export {
  getProvinceList,
  getCityList,
  getCity,
  getCityByName
};